export default __webpack_public_path__ + "static/genre_06-8845446e938babee5629bece889f9a60.png";